if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    
   // slick default setting
	let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 5000,disableOnInteraction: false}};

	// start slider default
    let allSwipper =[];

	document.querySelectorAll('.swiper-js').forEach((element,i) => {

		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;

		element.setAttribute(`data-swiper-${i}`,"");

		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

        allSwipper[i] = swiper;

	});

    //js animation parallax imagen
    const images = document.querySelectorAll('#home figure img, #default figure img:not(.no-parallax), #default-alternative figure img:not(.no-parallax');
    new Ukiyo(images,{
        scale: 1.2,
        speed: 1.5,
        willChange: true
    });

    //accordion Funcionality
	let acordionitems = document.querySelectorAll(".accordion-js h2");
	acordionitems.forEach((item) => {
		item.addEventListener("click", (element) => {
            element.target.classList.toggle("active");
            element.target.nextElementSibling.classList.toggle("active");
		});
	});
    
    // Menus funcionality
    const MenuLinks = document.querySelectorAll(".menus-block .tab-menu-js");
    const MenuItems = document.querySelectorAll(".menus-block .menuitem-js");
    const MenuSelect = document.querySelector(".menus-block #menuselect");
    let selectItem = null;
    if (MenuLinks) {
        MenuLinks.forEach((link ,i) => {
            link.addEventListener('click', function (e) {
                if (selectItem) {
                    selectItem.classList.remove('active');
                }
                e.target.classList.add('active');
                selectItem = e.target;
                MenuItems.forEach(menu => {
                    menu.classList.remove("active")
                    if (menu.dataset.gomenu === e.target.dataset.gomenu) {
                        menu.classList.add("active")
                    }
                });
            });
            if (i === 0) link.click();
        });
    }
    if (MenuSelect != null) {
        MenuSelect.addEventListener('change', select => {
            MenuItems.forEach(menu => { 
                menu.classList.remove("active");
                if ( MenuSelect.value  === menu.dataset.gomenu ) {
					menu.classList.add('active');
			    }
            });
        });
    }
})();